import {
  CREATE_PAYMENT_DATA, DELETE_PAYMENT_DATA, SET_PAYMENT_DATA,
  SET_PAYMENT_DATA_FOR_UPDATE, SET_UPDATED_PAYMENT_DATA
} from '../constants/payment-data';

const initialState = {
  list: [],
  initialValues: {},
};

const PaymentDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PAYMENT_DATA:
      return {
        ...state,
        list: action.list,
      };
    case CREATE_PAYMENT_DATA:
      return {
        ...state,
        list: [action.item].concat(state.list)
      };
    case DELETE_PAYMENT_DATA:
      return {
        ...state,
        list: state.list.filter(o => o.id !== action.id),
      };
    case SET_PAYMENT_DATA_FOR_UPDATE:
      return {
        ...state,
        initialValues: action.data,
      };
    case SET_UPDATED_PAYMENT_DATA:
      const updatedItem = action.data;
      return {
        ...state,
        initialValues: {},
        list: state.list.map(i => {
          if (i.id === updatedItem.id) {
            return {...updatedItem}
          }
          return i;
        })
      };
    default:
      return state;
  }
};

export default PaymentDataReducer;